"use client";

import React, { useMemo, FC } from "react";

import { BreadcrumbsItem } from "~/bff/types/BreadcrumbsItem";
import { Docs } from "~/bff/types/Docs";
import { SearchResultsFound } from "~/bff/types/SearchResultsFound";
import { ShoppingListProduct } from "~/bff/types/ShoppingListProduct";
import { WidgetInfo } from "~/bff/types/WidgetInfo";
import { LoadMoreButton } from "~/components/load-more-button/component";
import { LoadPreviousButton } from "~/components/load-previous-button/component";
import { getTestAutomationProps } from "~/helpers/test-automation-props";
import { Nullable } from "~/types/general.types";

import { ProductsGrid } from "./components/products-grid/component";
import { PRODUCTS_LIST_CLASSES } from "./constants";
import { ProductsGridContainer } from "./styled";

export type FlexibleProductType =
  | Nullable<Nullable<Docs>[]>
  | Nullable<ShoppingListProduct>[]
  | undefined;
export interface ProductsListProps {
  isLoading?: boolean;
  onLoadMore?: () => void;
  onLoadPrevious?: () => void;
  className?: string;
  products?: FlexibleProductType;
  totalCount?: Nullable<number>;
  pageSize: number;
  searchResultsFound?: SearchResultsFound;
  progressBarText?: Nullable<string>;
  loadMoreButtonText?: Nullable<string>;
  loadPreviousButtonText?: Nullable<string>;
  showPreviousButton?: boolean;
  layout?: string;
  breadcrumbs?: Nullable<Nullable<BreadcrumbsItem>[]>;
  hideLoadMore?: boolean;
  productToPageMap?: Map<string, number>;
  pageNumber?: React.RefObject<number>;
  restorationRef?: {
    markerId: Nullable<string>;
    scrollRestorationRef: React.RefObject<
      Nullable<HTMLSpanElement & HTMLAnchorElement>
    >;
  };
  widgetData?: Nullable<WidgetInfo>;
}

//TODO: Refactor this components according to component structure requirements
export const ProductsList: FC<ProductsListProps> = ({
  isLoading,
  onLoadMore,
  onLoadPrevious,
  className,
  totalCount,
  pageSize,
  products = [],
  progressBarText,
  loadMoreButtonText,
  loadPreviousButtonText,
  showPreviousButton,
  layout = "",
  breadcrumbs,
  hideLoadMore = false,
  productToPageMap,
  pageNumber,
  restorationRef,
  widgetData,
}) => {
  const shownProductsCount = useMemo(() => products?.length, [products]);
  return (
    <ProductsGridContainer
      className={className}
      {...getTestAutomationProps("products-loader")}
    >
      {showPreviousButton && (
        <LoadPreviousButton
          disabled={isLoading}
          pageSize={pageSize}
          onClick={onLoadPrevious}
          loadPreviousButtonText={loadPreviousButtonText}
          itemsMap={productToPageMap}
        />
      )}
      <ProductsGrid
        className={PRODUCTS_LIST_CLASSES.productGrid}
        products={products}
        layout={layout}
        breadcrumbs={breadcrumbs}
        productToPageMap={productToPageMap}
        restorationRef={restorationRef}
        pageNumberRef={pageNumber}
        widgetData={widgetData}
      />
      {!hideLoadMore && (
        <LoadMoreButton
          disabled={isLoading}
          totalCount={totalCount}
          itemsCount={shownProductsCount}
          pageSize={pageSize}
          onClick={onLoadMore}
          progressBarText={progressBarText}
          loadMoreButtonText={loadMoreButtonText}
          pageNumber={pageNumber}
          itemsMap={productToPageMap}
        />
      )}
    </ProductsGridContainer>
  );
};
